import { EcoRoute } from 'types';
import { useMapRouteChildrenToTabsMenuItem } from './useMapRouteChildrenToTabsMenuItem';
import { useRouteChildren } from './useRouteChildren';

/**
 * This hooks will automatically retrive all the children of a route
 * and return it as a tabs menu
 * 
 * @param path 
 * @returns 
 */
export const useRouteMenu = (path: string) => {
    const mapViewerMenuRoutes = useMapRouteChildrenToTabsMenuItem();
	const menus = useRouteChildren(path)

	return mapViewerMenuRoutes(menus as EcoRoute[], path);
};
